import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query-v4';
import { toast } from 'sonner';
import { HTTPError } from 'react-scale/lib/api-fetch';

function isLocalEnvironment() {
  return typeof window !== 'undefined' && window.location.hostname === 'localhost';
}

function handleGlobalError(error: any) {
  let errorMessage: string = 'Unknown error. Please try again.';
  if (error instanceof HTTPError) {
    const maybeErrorMessage = error.response?.message ?? error.response?.error;
    if (typeof maybeErrorMessage === 'string') errorMessage = maybeErrorMessage;
    if (error.response?.status === 401) {
      errorMessage = 'You are not signed in. Please sign in and try again.';
    }
  }
  toast.error(errorMessage);
}

const queryCache = new QueryCache({
  onError: handleGlobalError,
});

const mutationCache = new MutationCache({
  onError: handleGlobalError,
});

export const queryClient = isLocalEnvironment()
  ? new QueryClient({
      queryCache,
      mutationCache,
      defaultOptions: {
        mutations: {
          retry: 1,
          useErrorBoundary: false,
        },
        queries: {
          retry: 1,
          refetchOnWindowFocus: false,
          useErrorBoundary: false,
          staleTime: 5 * 60 * 1000,
        },
      },
    })
  : new QueryClient({
      queryCache,
      mutationCache,
      defaultOptions: {
        mutations: {
          retry: 1,
          useErrorBoundary: false,
        },
        queries: {
          retry: 1,
          refetchOnWindowFocus: false,
          useErrorBoundary: false,
          staleTime: 5 * 60 * 1000,
        },
      },
    });
